import React, { FC } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface ICancelRepairDialogProps {
  handleCancel: VoidFunction;
  handleClose: VoidFunction;
  isLoading: boolean;
  open: boolean;
}

const CancelRepairDialog: FC<ICancelRepairDialogProps> = ({
  handleCancel,
  handleClose,
  isLoading,
  open,
}) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Cancel Repair</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to cancel this repair? If payment was made, it will be refunded.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
        >
          No
        </Button>
        <Button
          color="error"
          disabled={isLoading}
          onClick={handleCancel}
        >
          Yes, Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelRepairDialog;